import { Injectable } from '@angular/core';

@Injectable()
export class AppGlobals {
    readonly baseAppUrl: string = "";
    readonly baseLiosUrl: string = "";
    readonly baseAssetsUrl: string = "";
    readonly liosHostName: string = "";

    constructor() {
        // localStorage.setItem('JT', 'eyJhbGciOiJIUzI1NiJ9.eyJVU0VSIjp7InVzZXJJZCI6Im5hbm5lbSIsImxvZ2lzdGljc1BvaW50IjpbXSwicm9sZXMiOnsiV1QgQWRtaW5pc3RyYXRvciI6IldUIEFkbWluaXN0cmF0b3IiLCJURU1BIFB1cmNoYXNpbmciOiJURU1BIFB1cmNoYXNpbmciLCJBZG1pbiI6IkFkbWluIiwiTVRNIFBsYW5uZXIiOiJNVE0gUGxhbm5lciIsIkJpbGxpbmcgQWRtaW5pc3RyYXRvciI6IkJpbGxpbmcgQWRtaW5pc3RyYXRvciJ9LCJzdXBwbGllckNvZGVzIjp7fSwiYWRtaW4iOnRydWUsInJhY2tGbGFnIjp0cnVlLCJmdWxsTmFtZSI6IkFyanVuIFJlZGR5IEFubmVtIiwiZmlyc3ROYW1lIjoiQXJqdW4gUmVkZHkiLCJsYXN0TmFtZSI6IkFubmVtIiwidXNlckVtYWlsIjoibmFnYXJqdW5hLmFubmVtQHRtbmF0ZXN0LmNvbSIsInBsYW50Q29kZSI6bnVsbCwic2N2QWRtaW4iOnRydWUsImNyb3NzRG9ja3MiOltdLCJhY3Rpb25zIjpbIkxQX0RBU0hCT0FSRCIsIkNST1NTRE9DS19NQU5BR0VSIiwiU1VQUExJRVJfREFTSEJPQVJEIiwiU0VBUkNIIiwiU0hJUE1FTlRfTE9BRCIsIkNPTVBMSUFOQ0VfREFTSEJPQVJEIiwiUEFDS0lOR19MSVNUIiwiU0hPUlRBR0VfTk9USUZJQ0FUSU9OIiwiU0tJRF9CVUlMRCIsIkNST1NTRE9DS19EQVNIQk9BUkQiXSwibHBDb2RlcyI6W119fQ.0Qk-RDJPO4nndH7EqjCpuwdmYbidI6uaQLl8Ct0YjtY')
        
        if(location.hostname.toLowerCase().includes("ts.stage.portal.toyotasupplier.com")){
            this.liosHostName = "qa.subprod.newlios.toyota.com";
        }
        
        this.baseAppUrl += location.protocol + '//' + location.hostname;
        if (location.hostname == "localhost") { // NOSONAR
            this.baseAppUrl += ":8081";
            this.baseAssetsUrl = this.baseAppUrl + "/ng-dd";
        } else {
            this.baseAppUrl += (location.port ? ':' + location.port : '');
            this.baseAssetsUrl = this.baseAppUrl + "/ng-dd";
        }

        this.baseLiosUrl = location.protocol + '//' + this.liosHostName + "/home";
        this.baseAppUrl += "/LiosDDApi/rest";     
        // this.baseAppUrl = 'https://lios-api.qa.toyota.com/lios/alloapi'  
        this.baseAppUrl = 'https://ts.stage.portal.toyotasupplier.com/LiosDDApi/rest'    

        if (location.hostname == "localhost") { // NOSONAR
            this.baseLiosUrl = "http://localhost:8080/lios/index?userID=sramanee";
        }
        console.info('App URL: ' + this.baseAppUrl);
        console.info('Lios URL: ' + this.baseLiosUrl);
        console.info('Assets URL: ' + this.baseAssetsUrl);
    }
}